// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { Module, VuexModule, VuexMutation, getModule, VuexAction } from 'nuxt-property-decorator';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { store } from '@/store';

import TRUCKS from '@/store/modules/TruckModule';

import { groupBy } from '@/_helpers/misc_helper';

import { ITruckFilterSettings } from '@/types/truck';

interface StringIndex {
	[key: string]: any;
}

@Module({
	name: 'MAP',
	store, // this basically injects the module in the store dynamically thanks to next line
	dynamic: true,
	stateFactory: true // apparently necessary/better for Nuxt
})
class MAP extends VuexModule {
	hasUnappliedFilters = false;

	current_filter = new ITruckFilterSettings();

	all_trucks_per_domain = {} as any;

	saved_map_position = null as { center: { lat: number; lng: number }; zoom: number } | null;

	reset_filter = false;

	// ------------------------------------------------
	// ------------- Mutations ------------------------
	// ------------------------------------------------

	@VuexMutation
	resetVans() {
		this.all_trucks_per_domain = {} as any[];
	}

	@VuexMutation
	updateTrucksList(payload: any[]) {
		this.all_trucks_per_domain = {} as any[];
		// Group trucks by their BUs
		const result = {} as StringIndex;
		// Create a list of BUs containing their respective trucks keyed by their truck_id + site_id
		Array.from(groupBy(payload, (truck: any) => truck.bu)).map((el: [string, any[]]) => {
			const trucks = {} as any;
			el[1].forEach((truck: any) => {
				// Create a truck list with keys being the truck ID + site_id
				const key = truck.id + truck.position.site_id;
				trucks[key] = truck;
			});
			return (result[el[0].toLowerCase()] = trucks);
		});

		this.all_trucks_per_domain = result;
	}

	@VuexMutation
	updateCurrentFilter(filter: ITruckFilterSettings) {
		this.current_filter = filter;
		this.hasUnappliedFilters = true;
		sessionStorage.setItem('map-filter', JSON.stringify(filter));
	}

	@VuexMutation
	resetFilterOnMap(bool: boolean) {
		this.reset_filter = bool;
	}

	@VuexMutation
	storeMapPosition(payload: typeof this.saved_map_position) {
		this.saved_map_position = payload;
	}

	// ------------------------------------------------
	// ------------- Actions --------------------------
	// ------------------------------------------------

	@VuexAction
	TRUCK_LIST(filter?: ITruckFilterSettings) {
		// Save filter to always apply current one if no filter passed in function
		if (filter) {
			this.context.commit('updateCurrentFilter', JSON.parse(JSON.stringify(filter)));
		}

		const trucks = JSON.parse(JSON.stringify(TRUCKS.list));
		const list_as_array = [];
		for (const i in trucks) {
			list_as_array.push(trucks[i]);
		}

		this.context.commit('updateTrucksList', list_as_array);
	}

	@VuexAction
	STORE_MAP_POSITION(payload: typeof this.saved_map_position) {
		this.context.commit('storeMapPosition', payload);
	}

	@VuexAction
	CLEAR_TRUCKS() {
		this.context.commit('resetVans');
	}
}

export default getModule(MAP);
